module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-tpp_3124891.png";